import { getBy } from '@tanstack/vue-form'
import type { AnyFormApi } from '@tanstack/vue-form'

import { valuesEqual } from '~/utils/valuesEqual'

/** Verdicts at nested paths (`rows[3].v`) under an edited field whose own value changed; untouched siblings keep theirs. */
export const clearChangedNestedErrors = <TFormData extends object>(
  form: AnyFormApi,
  field: string,
  previous: TFormData,
  current: TFormData
): void => {
  for (const path of Object.keys(form.state.fieldMeta)) {
    const isNested = path.startsWith(`${field}[`) || path.startsWith(`${field}.`)
    if (isNested && !valuesEqual(getBy(previous, path), getBy(current, path))) {
      form.setFieldMeta(path, (meta) => ({ ...(meta ?? {}), errorMap: {} }))
    }
  }
}
